module.exports = __webpack_public_path__ + "static/media/Kotlin.5ae95572.svg";